import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errText } from "../../lib/api";
import { Switch } from "../../components/ui/switch";

export function BreederBoostToggle() {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/admin/site/breeder-boost").then((r) => setOn(r.data.enabled)).catch(() => {}); }, []);
  const toggle = async (v) => {
    try {
      const { data } = await api.put("/admin/site/breeder-boost", { enabled: v });
      setOn(data.enabled);
      toast.success(data.enabled ? "Breeder Alert Boost is on" : "Breeder Alert Boost is off");
    } catch (e) { toast.error(errText(e)); }
  };
  if (on === null) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-5 mb-6 flex items-start justify-between gap-4" data-testid="breeder-boost-card">
      <div className="flex gap-3">
        <span className="h-10 w-10 shrink-0 rounded-xl bg-[#FFF4F0] flex items-center justify-center"><BellRing size={18} className="text-[#F5551E]" /></span>
        <div>
          <h3 className="font-display font-bold text-[#12234A]">Breeder Alert Boost</h3>
          <p className="text-xs text-slate-500 mt-0.5 max-w-xl">When a Verified Breeder posts or edits a litter, show how many people are waiting for that breed near them: “more like this” alert sign-ups, matching saved searches and their followers. Counts only, never names or emails.</p>
        </div>
      </div>
      <label className="flex items-center gap-2 text-sm font-semibold text-[#12234A] shrink-0">
        <Switch checked={on} onCheckedChange={toggle} data-testid="breeder-boost-toggle" /> {on ? "On" : "Off"}
      </label>
    </div>
  );
}
